import { format } from 'date-fns'
import type { DateRange } from 'react-day-picker'
import type { UseFormSetValue } from 'react-hook-form'
import type { PackagesFormStateType } from '../types'

export function handleSingleDateCalendarChange(
  setValue: UseFormSetValue<PackagesFormStateType>,
  watchLabel: keyof PackagesFormStateType,
  date: Date
) {
  const formattedDate = format(date, 'yyyyMMdd')
  setValue(watchLabel, formattedDate)
}

export function handleDateRangeCalendarChange(
  setValue: UseFormSetValue<PackagesFormStateType>,
  watchStartLabel: keyof PackagesFormStateType,
  watchEndLabel: keyof PackagesFormStateType,
  dates?: DateRange
) {
  if (dates?.from) {
    const startDate = format(dates.from, 'yyyyMMdd')
    setValue(watchStartLabel, startDate)
  }
  if (dates?.to) {
    const endDate = format(dates.to, 'yyyyMMdd')
    setValue(watchEndLabel, endDate)
  }
}

export const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}
